import Reveal from '@/components/base/Reveal';
import { storyParagraphs, storyQuote } from '@/mocks/about';

export default function Story() {
  return (
    <section className="relative py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <Reveal>
            <div className="relative">
              <div className="absolute -inset-4 rounded-3xl bg-gradient-to-tr from-primary-500/15 via-transparent to-background-300/40 blur-2xl" />
              <div className="relative rounded-2xl overflow-hidden border border-white/10">
                <div className="relative w-full aspect-[4/3]">
                  <img
                    src="/assets/images/how-it-works.jpg"
                    alt="Joshua and Lauren Hastings building their business together"
                    title="Joshua & Lauren Hastings — Building a Growth Business"
                    className="absolute opacity-70 inset-0 w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </Reveal>

          {/* Story */}
          <Reveal delay={100}>
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
              How It Started
            </span>
            <h2 className="mt-6 font-heading font-bold text-3xl md:text-4xl text-foreground-950">
              From Solving Our Own Problem to Helping Businesses Grow
            </h2>

            <div className="mt-6 space-y-4">
              {storyParagraphs.map((p) => (
                <p key={p} className="text-foreground-600 leading-relaxed">
                  {p}
                </p>
              ))}
            </div>

            <blockquote className="mt-8 rounded-xl border-l-4 border-primary-500 bg-background-100 p-6">
              <p className="font-heading font-medium text-lg md:text-xl text-foreground-950 leading-relaxed italic">
                &ldquo;{storyQuote}&rdquo;
              </p>
            </blockquote>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
